var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var treeLocation = require('../locations/treeLocation');
var treeEquipment = require('../locations/treeEquipment');
var moveEquipmentModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


moveEquipmentModal.editDialogue = function (equipmentRecord, options) {
  moveEquipmentModal.newLocationRecord = prop('');
  moveEquipmentModal.newParentEquipment = prop('');
  moveEquipmentModal.errors = [];
  moveEquipmentModal.equipmentRecord = equipmentRecord;
  moveEquipmentModal.isLocationOf = equipmentRecord.in_isLocationOf && Array.isArray(equipmentRecord.in_isLocationOf) ? equipmentRecord.in_isLocationOf[0] : null;
  moveEquipmentModal.hasComponent = equipmentRecord.in_hasComponent && Array.isArray(equipmentRecord.in_hasComponent) ? equipmentRecord.in_hasComponent[0] : null;
  moveEquipmentModal.editMode = prop(options && options.type === 'location' ? 'location' : 'equipment');

  moveEquipmentModal.hasLocationEdge = Boolean(moveEquipmentModal.isLocationOf && moveEquipmentModal.isLocationOf['@rid']);
  moveEquipmentModal.hasParentEdge = Boolean(moveEquipmentModal.hasComponent && moveEquipmentModal.hasComponent['@rid']);

  if (moveEquipmentModal.isLocationOf && moveEquipmentModal.isLocationOf.out) {
    moveEquipmentModal.newLocationRecord(moveEquipmentModal.isLocationOf.out);
  } else {
    moveEquipmentModal.newLocationRecord('');
  }

  if (moveEquipmentModal.hasComponent && moveEquipmentModal.hasComponent.out) {
    moveEquipmentModal.newParentEquipment(moveEquipmentModal.hasComponent.out);
  } else {
    moveEquipmentModal.newParentEquipment('');
  }

  const submit = () => {
    const equipmentRid = equipmentRecord['@rid'] ? equipmentRecord['@rid'].slice(1) : null;
    if (!equipmentRid) return;
    moveEquipmentModal.errors = [];

    const handleSuccess = () => {
      key.unbind('enter');
      if (options?.submitCallback) options.submitCallback();
      modal.vm.close();
      m.redraw();
    };
    const handleError = (error) => {
      var message = 'Unable to update equipment relationship.';
      if (typeof error === 'string') {
        message = error;
      } else if (error && typeof error.error === 'string') {
        message = error.error;
      } else if (error && error.response && typeof error.response.error === 'string') {
        message = error.response.error;
      } else if (error && typeof error.message === 'string') {
        message = error.message;
      }
      moveEquipmentModal.errors = [message];
      m.redraw();
    };
    const showValidationError = (message) => {
      moveEquipmentModal.errors = [message];
      m.redraw();
      return false;
    };

    if (moveEquipmentModal.editMode() === 'location') {
      const newLocation = moveEquipmentModal.newLocationRecord();
      if (!newLocation || !newLocation['@rid']) {
        return showValidationError('Select a location before saving.');
      }
      const newLocationRid = newLocation['@rid'].slice(1);
      const existingEdge = moveEquipmentModal.isLocationOf;
      const currentLocationRid = existingEdge && existingEdge.out && existingEdge.out['@rid'];

      if (currentLocationRid && currentLocationRid === newLocation['@rid']) {
        return handleSuccess();
      }

      if (existingEdge && existingEdge['@rid']) {
        return loaders
          .requestWithLoader({
            loader: 'submit',
            url: `/api/v1/islocationof/${existingEdge['@rid'].slice(1)}`,
            method: 'PUT',
            body: {
              out: newLocationRid,
              in: equipmentRid,
            },
          })
          .then(handleSuccess)
          .catch(handleError);
      }

      return loaders
        .requestWithLoader({
          loader: 'submit',
          url: '/api/v1/islocationof/',
          method: 'POST',
          body: {
            out: newLocationRid,
            in: equipmentRid,
          },
        })
        .then(handleSuccess)
        .catch(handleError);
    }

    if (moveEquipmentModal.editMode() === 'equipment') {
      const newParent = moveEquipmentModal.newParentEquipment();
      if (!newParent || !newParent['@rid']) {
        return showValidationError('Select a parent equipment before saving.');
      }
      if (newParent['@rid'] === equipmentRecord['@rid']) {
        return showValidationError('Select a different parent equipment before saving.');
      }

      const newParentRid = newParent['@rid'].slice(1);
      const existingEdge = moveEquipmentModal.hasComponent;
      const currentParentRid = existingEdge && existingEdge.out && existingEdge.out['@rid'];

      if (currentParentRid && currentParentRid === newParent['@rid']) {
        return handleSuccess();
      }

      if (existingEdge && existingEdge['@rid']) {
        return loaders
          .requestWithLoader({
            loader: 'submit',
            url: `/api/v1/hasComponent/${existingEdge['@rid'].slice(1)}`,
            method: 'PUT',
            body: {
              out: newParentRid,
              in: equipmentRid,
            },
          })
          .then(handleSuccess)
          .catch(handleError);
      }

      return loaders
        .requestWithLoader({
          loader: 'submit',
          url: '/api/v1/hasComponent/',
          method: 'POST',
          body: {
            parentEquipment: newParentRid,
            childEquipment: equipmentRid,
          },
        })
        .then(handleSuccess)
        .catch(handleError);
    }
  };

  const relationCount = (moveEquipmentModal.hasLocationEdge ? 1 : 0) + (moveEquipmentModal.hasParentEdge ? 1 : 0);
  const canDeleteRelation = function () {
    if (relationCount <= 1) return false;
    if (moveEquipmentModal.editMode() === 'location') {
      return moveEquipmentModal.hasLocationEdge;
    }
    return moveEquipmentModal.hasParentEdge;
  };

  const removeRelation = () => {
    if (!canDeleteRelation()) return;
    const isLocationMode = moveEquipmentModal.editMode() === 'location';
    const edge = isLocationMode ? moveEquipmentModal.isLocationOf : moveEquipmentModal.hasComponent;
    if (!edge || !edge['@rid']) return;
    const endpoint = isLocationMode ? 'islocationof' : 'hasComponent';
    return loaders
      .requestWithLoader({
        loader: 'submit',
        url: `/api/v1/${endpoint}/${edge['@rid'].slice(1)}`,
        method: 'DELETE',
      })
      .then(() => {
        key.unbind('enter');
        if (options?.submitCallback) options.submitCallback();
        modal.vm.close();
        m.redraw();
      });
  };
  
  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(moveEquipmentModal.editMode() === 'location' ? 'Set Location' : 'Set Parent Equipment');
  modal.vm.body = moveEquipmentModal.view;
  const buttons = [
    {
      label: "Save",
      class: canDeleteRelation() ? "btn-good dib" : "btn-good",
      func: submit
    }
  ];
  if (canDeleteRelation()) {
    buttons.unshift({
      label: "Delete",
      class: "dib mr2 red",
      func: removeRelation
    });
  }
  modal.vm.buttons(buttons);
  modal.vm.open();
}


moveEquipmentModal.view = function () {
  var mode = moveEquipmentModal.editMode();
  var equipmentRid = moveEquipmentModal.equipmentRecord && moveEquipmentModal.equipmentRecord['@rid'];
  var functionalPath = Array.isArray(moveEquipmentModal.equipmentRecord && moveEquipmentModal.equipmentRecord.path)
    ? moveEquipmentModal.equipmentRecord.path
    : [];
  var locationPathSource = Array.isArray(moveEquipmentModal.equipmentRecord && moveEquipmentModal.equipmentRecord.locationPath)
    ? moveEquipmentModal.equipmentRecord.locationPath
    : [];
  var formatName = function (node) {
    if (!node) return '';
    var name = node.name || node['@class'] || '';
    if (typeof name === 'string' && name.toLowerCase() === 'root') {
      return 'Home';
    }
    return name;
  };
  var buildPathString = function (nodes) {
    if (!Array.isArray(nodes)) return '';
    return nodes
      .filter(Boolean)
      .map(formatName)
      .filter(Boolean)
      .join(' / ');
  };
  var findPathForRid = function (pathArray, rid) {
    if (!rid || !Array.isArray(pathArray) || !pathArray.length) return '';
    var idx = pathArray.findIndex(function (node) {
      return node && node['@rid'] === rid;
    });
    if (idx === -1) {
      var normalized = typeof rid === 'string' && rid.startsWith('#') ? rid.slice(1) : rid;
      idx = pathArray.findIndex(function (node) {
        if (!node || !node['@rid']) return false;
        var nodeRid = node['@rid'];
        return nodeRid === normalized || nodeRid === ('#' + normalized);
      });
    }
    if (idx === -1) return '';
    return buildPathString(pathArray.slice(0, idx + 1));
  };

  var infoSection;
  if (mode === 'location') {
    var currentLocation = moveEquipmentModal.isLocationOf && moveEquipmentModal.isLocationOf.out;
    var locationName = formatName(currentLocation);
    var locationPath = '';
    if (currentLocation) {
      if (Array.isArray(currentLocation.path) && currentLocation.path.length) {
        locationPath = buildPathString(currentLocation.path);
      }
      if (!locationPath) {
        locationPath = findPathForRid(locationPathSource, currentLocation['@rid']);
      }
    }
    infoSection = m('div.mb3', [
      m('div.mb1', 'Current Location'),
      currentLocation
        ? m('div', [
            m('div', locationName || currentLocation['@rid']),
            locationPath && locationPath !== locationName ? m('div.f6', locationPath) : null
          ])
        : m('div.mid-gray', 'No location assigned')
    ]);
  } else {
    var currentParent = moveEquipmentModal.hasComponent && moveEquipmentModal.hasComponent.out;
    var parentName = formatName(currentParent);

    var parentPath = '';
    if (currentParent) {
      if (Array.isArray(currentParent.path) && currentParent.path.length) {
        parentPath = buildPathString(currentParent.path);
      }
      if (!parentPath) {
        parentPath = findPathForRid(functionalPath, currentParent['@rid']);
      }
    }
    infoSection = m('div.mb3', [
      m('div.mb1', 'Current Parent Equipment'),
      currentParent
        ? m('div', [
            parentPath && parentPath !== parentName ? m('div.f6.gray', parentPath) : null,
            m('div.gray', parentName || currentParent['@rid']),
          ])
        : m('div.mid-gray', 'No parent equipment assigned')
    ]);
  }

  var tree =
    mode === 'location'
      ? m(treeLocation, {
          selectedNode: moveEquipmentModal.newLocationRecord
        })
      : m(treeEquipment, {
          selectedNode: moveEquipmentModal.newParentEquipment,
          excludedRid: equipmentRid
        });

  return m('form', { role: 'form' }, [
    moveEquipmentModal.errors && moveEquipmentModal.errors.length ? moveEquipmentModal.errorView() : null,
    infoSection,
    tree
  ]);
}

module.exports = moveEquipmentModal;
